module.exports = __webpack_public_path__ + "static/media/f.43da6d13.m4a";